import { useContext } from 'react';
import { Box, Card, CardContent, CardMedia, Typography } from '@mui/material';
import NorthIcon from '@mui/icons-material/North';
import { WeatherStartContext } from '../../contexts';
import { Loading } from '../components';
import { getDate, getAT, getDateSun, getDayLong } from '../../format-date';

export const WeatherStart = ({ cityName }) => {
    const state = useContext(WeatherStartContext);

    return (
        <>
            {(!state.length && !Object.keys(state).length) ?
                <Loading /> :
                <Box mb={3} sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Card sx={{ maxWidth: 700, backgroundColor: 'rgba(255, 255, 255, .6)' }} >
                        <CardContent>
                            <Typography variant='h5' component='div'>
                                {cityName}
                            </Typography>
                            <Typography variant='h5' component='div'>
                                {getDate(state.date)}
                            </Typography>
                            <Typography variant='h5' component='div'>
                                {Math.ceil(state.temper)} °С
                            </Typography>
                            <Typography variant='body2' color='text.secondary' sx={{ fontSize: '18px' }}>
                                Відчувається як: {Math.ceil(state.feel)} °С
                            </Typography>
                            <Typography variant='body2' color='text.secondary' sx={{ fontSize: '18px' }}>
                                {state.description}
                            </Typography>
                            <div className='weather-img'>
                                <CardMedia
                                    component='img'
                                    image={`http://openweathermap.org/img/wn/${state.icon}@2x.png`}
                                    alt={state.alt}
                                    sx={{ maxWidth: '100px' }}
                                />
                            </div>
                            <Typography variant='body2' sx={{ fontSize: '18px' }}>
                                Атмосферний тиск {state.grnd ?
                                    getAT(state.grnd) : state.pressure ? getAT(state.pressure) : 0} мм. рт. ст.
                            </Typography>
                            <Typography variant='body2' sx={{ fontSize: '18px' }}>
                                Вологість: {state.humidity ? state.humidity : 0} %
                            </Typography>
                            <Typography variant='body2' sx={{ fontSize: '18px' }}>
                                Хмарність: {state.clouds ? state.clouds : 0} %
                            </Typography>
                            <div>
                                <NorthIcon sx={{ transform: `rotate(${state.deg}deg)` }} />
                            </div>
                            <Typography variant='body2' sx={{ fontSize: '18px' }}>
                                Швидкість вітру {state.speed ? Math.ceil(state.speed) : 0} м/с
                            </Typography>
                            <Typography variant='body2' sx={{ fontSize: '18px' }}>
                                Пориви вітру до {state.gust ? Math.ceil(state.gust) : 0} м/с
                            </Typography>
                            <Typography variant='body2' sx={{ fontSize: '18px' }}>
                                Видимість {state.visibility ? state.visibility : 0} м
                            </Typography>
                            <Typography variant='body2' sx={{ fontSize: '18px' }}>
                                Тривалість світлового дня: {getDayLong(state.sunrise, state.sunset)}
                            </Typography>
                            <Typography variant='body2' sx={{ fontSize: '18px' }}>
                                Схід сонця: {getDateSun(state.sunrise)}
                            </Typography>
                            <Typography variant='body2' sx={{ fontSize: '18px' }}>
                                Захід сонця: {getDateSun(state.sunset)}
                            </Typography>
                        </CardContent>
                    </Card>
                </Box>
            }</>
    )
}